import { LocalStorage, LocalStorageKeys } from 'helpers/localStorage';
import { useCallback, useState } from 'react';
import type { TAdditionalDataOrigin } from './types';

const originStorage = new LocalStorage<TAdditionalDataOrigin, null>(
  LocalStorageKeys.AdditionalDataOrigin,
  null,
  () => sessionStorage
);

export const rememberAdditionalDataOrigin = (origin: TAdditionalDataOrigin) =>
  originStorage.replace(origin);

// Modal props are dropped when the ?modal= url restores the form after a
// reload, so the origin is mirrored into storage until the form is done with.
export const useAdditionalDataOrigin = (openedFrom?: TAdditionalDataOrigin) => {
  const [restored] = useState(() => originStorage.get() ?? undefined);

  const forgetOrigin = useCallback(() => originStorage.remove(), []);

  return { origin: openedFrom ?? restored, forgetOrigin };
};
